import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { AsyncLoader, Loading, useAuth } from '@vfpf/vfpf-shared';
import { ROUTE_CONFIG } from './configuration';
import { MainService } from './services';

const Inloggen = AsyncLoader(() => import('./pages/InUitLoggen/Inloggen'));
const InloggenEherkenning = AsyncLoader(() => import('./pages/InUitLoggen/InloggenEherkenning'));
const Uitloggen = AsyncLoader(() => import('./pages/InUitLoggen/Uitloggen'));
const WrapperMain = AsyncLoader(() => import('./pages/MainWrapper'));

const PreadviesFormulierComponent = () => <WrapperMain activeTab="preAdviesFormulier" />;
const MijnFormulierComponent = () => <WrapperMain activeTab="mijnFormulieren" />;
const PageNotFoundComponent = () => <p> Pagina niet gevonden </p>;

export const Routes: React.FC = () => {
  const { authState } = useAuth();

  if (authState.status === 'authenticated') {
    return (
      <MainService>
        <Switch>
          <Route
            path={ROUTE_CONFIG.subRoutes.Formulieren.subRoutes.PreAdviesFormulier.path}
            component={PreadviesFormulierComponent}
          />
          <Route
            path={ROUTE_CONFIG.subRoutes.Formulieren.subRoutes.MijnFormulieren.path}
            component={MijnFormulierComponent}
          />
          <Route path="/uitloggen" component={Uitloggen} />
          <Route component={PageNotFoundComponent} />
        </Switch>
      </MainService>
    );
  }

  if (authState.status === 'unauthenticated') {
    return (
      <MainService>
        <Switch>
          <Route path="/inloggen/eherkenning" component={InloggenEherkenning} />
          <Route path="/inloggen" component={Inloggen} />
          <Route>
            <Redirect
              to={{
                pathname: '/inloggen',
                search: window.location.search,
              }}
            />
          </Route>
        </Switch>
      </MainService>
    );
  }

  return (
    <MainService>
      <Loading />
    </MainService>
  );
};
